import "@fontsource/barlow-semi-condensed/400.css";
import "@fontsource/barlow-semi-condensed/600.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { sandboxRequested } from "./env";
import { session } from "./game/session";
import { installPixelUnits } from "./ui/pixel";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Élément #root introuvable");

installPixelUnits();
if (sandboxRequested()) session.sandbox();
else void session.boot();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
